/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Verify_LabelInputs */

const en_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify and continue`)
};

const de_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen und fortfahren`)
};

const pt_br2_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar e continuar`)
};

const tr_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrula ve devam et`)
};

const zh_cn2_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证并继续`)
};

const zh_hk2_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證並繼續`)
};

const ko_kr2_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증하고 계속`)
};

const ru_ru2_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить и продолжить`)
};

const es_419_login_page_verify_label = /** @type {(inputs: Login_Page_Verify_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar y continuar`)
};

/**
* | output |
* | --- |
* | "Verify and continue" |
*
* @param {Login_Page_Verify_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_verify_label = /** @type {((inputs?: Login_Page_Verify_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Verify_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_verify_label(inputs)
	if (locale === "de") return de_login_page_verify_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_verify_label(inputs)
	if (locale === "tr") return tr_login_page_verify_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_verify_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_verify_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_verify_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_verify_label(inputs)
	return es_419_login_page_verify_label(inputs)
});